module.exports = __webpack_public_path__ + "fonts/AvenirBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirBold.ttf
// module id = 481
// module chunks = 12